import * as React from 'react';
import ReactDOMServer from 'react-dom/server';
import jsPDF from 'jspdf';
import { toast } from 'react-hot-toast';
import { IExpense } from '../../@types';
import { ExpenseDocument } from '../../components/expense/expenseDocument';

interface useDownloadExpenseType {
  isDownloading: boolean;
  downloadExpense: (expenses: IExpense[], expenseId: string) => void;
}

type useDownloadExpenseReturnType = () => useDownloadExpenseType;

const useDownloadExpense: useDownloadExpenseReturnType = () => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const downloadExpense = async (expenses: IExpense[], expenseId: string) => {
    try {
      setIsDownloading(true);

      const expenseToHTML = ReactDOMServer.renderToStaticMarkup(<ExpenseDocument expense={expenses} />);

      const doc = new jsPDF({
        unit: 'px',
        floatPrecision: 'smart',
        hotfixes: ['px_scaling'],
      });

      doc.html(expenseToHTML, {
        callback: (doc) => {
          doc.save(`expense-report-${expenseId}.pdf`);
        },
      });
      setIsDownloading(false);
      toast.success(`Downloaded expense-report-${expenseId}.pdf Successfully!`);
    } catch (e: any) {
      setIsDownloading(false);
      toast.error('An error occured: ' + e.message);
    }
  };

  return { isDownloading, downloadExpense };
};

export { useDownloadExpense };
